
import { Row, Col, Typography, Card } from '../ui/ot'
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const MoreContent = ({ prefixTitle = "", title = "首頁" }) => {
    const [blogData, setBlogData] = useState("");
    const { blogId } = useParams();

    useEffect(() => {
        axios
            .get("/dynamicWebsite/frontend/blog", {
                params: {
                    blog_id: blogId,
                },
            })
            .then((response) => {
                if (response?.data?.data && response?.data?.data.length !== 0) {
                    let blogDataTemp = response?.data?.data?.find((_) => true)
                    document.title = `${prefixTitle} | ${blogDataTemp?.title}`
                    setBlogData(blogDataTemp);
                    patchBlogClick();
                }
            });
    }, [blogId]);

    const patchBlogClick = () => {
        axios
            .patch("/dynamicWebsite/frontend/blog/click", [
                {
                    blog_id: blogId,
                },
            ])
            .then((response) => { });
    };

    return (
        <Row gutter={[8, 8]}
            style={{
                padding: "1rem",
            }}>
            <Col span={24}>
                <Row gutter={[8, 8]}
                    align={'middle'}
                    justify={'center'}>
                    <Col xxl={12}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}>
                        <Typography.Title level={3}>
                            標題：{blogData?.title}
                        </Typography.Title>
                    </Col>
                    <Col xxl={12}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}
                        style={{ textAlign: "right" }}>
                        文章點擊人次：{blogData?.view_count + 1}
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Card>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: blogData.more_content,
                                }}
                                style={{
                                    maxWidth: '100%',
                                    overflowX: 'auto',
                                    wordWrap: 'break-word',
                                    boxSizing: 'border-box',
                                    tableLayout: 'auto'
                                }}
                            />
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    );
};
export default MoreContent;
